<ng-container *ngIf="!isIframe && logined">
  <app-header></app-header>
  <router-outlet></router-outlet>
</ng-container>
